import { createAction, props } from "@ngrx/store";


export const setSortByResultsPage = createAction('[SortOptionsByPage] Set sort by results page', props<{ sortBy: string }>());

export const setOrderByResultsPage = createAction('[SortOptionsByPage] Set order by results page', props<{ orderBy: string }>());

export const setSortByTimeline = createAction('[SortOptionsByPage] Set sort by timeline page', props<{ sortBy: string }>());
    
export const setOrderByTimeline = createAction('[SortOptionsByPage] Set order by timeline', props<{ orderBy: string }>());

export const clearSortOptions = createAction('[SortOptionsByPage] Clear sort options');
